import {
  IntegrationChannelType,
  IntegrationInputData,
} from 'generated/graphql';

export const getCohortIntegrationData = (
  channelType: IntegrationChannelType,
): IntegrationInputData => {
  switch (channelType) {
    case IntegrationChannelType.Amplitude:
      return { amplitude: {} };
    case IntegrationChannelType.MixPanel:
      return { mixpanel: {} };
    default:
      return {};
  }
};
